import type { HTMLAttributes } from "react";

/** Porté à l'identique depuis apps/web/components/ui/Card.tsx (aucune dépendance Next.js dans l'original). */
export type CardProps = HTMLAttributes<HTMLDivElement>;

/** Conteneur neutre réutilisable (CarteProduit, CarteArticle, panneaux…). */
export function Card({ className = "", ...props }: CardProps) {
  return <div className={["rounded-sm border border-line bg-white", className].join(" ")} {...props} />;
}
